import { Pipe, PipeTransform } from '@angular/core';
import { DateUtilitiesService } from '../../utilities/date-utilities.service';

@Pipe({
  name: 'dateFormat',
  standalone: true,
})
export class DateFormatPipe implements PipeTransform {
  public transform(value: string, format = 'DD MMMM YYYY'): string {
    if (!value) return '';

    if (/^\d{1,2}\s\w+$/.test(value)) {
      return value;
    }

    return DateUtilitiesService.convertUTCToUserFormatted(value, false, format);
  }
}
